import { Container, Skeleton, Stack } from "@mui/material";
import { type FC } from "react";

import { CategoriesSkeleton } from "~/feature/categories/components/Categories/CategoriesSkeleton";
import * as CategoriesLayoutStyled from "~/feature/categories/layouts/CategoriesLayout/CategoriesLayout.styles";
import { CoreChartSkeleton } from "~/feature/chart/components/CoreChart";
import * as Styled from "~/feature/event/components/EventContent/EventContent.styles";
import { EventHeaderSkeleton } from "~/feature/event/components/EventHeader/EventHeaderSkeleton";
import { MarketCalculatorSkeleton } from "~/feature/event/components/MarketCalculator/MarketCalculator/MarketCalculatorSkeleton";
import { MarketsTabsSkeleton } from "~/feature/event/components/MarketsTabs/MarketsTabsSkeleton";
import { NewsFeedSkeleton } from "~/feature/news/components/NewsFeedSkeleton";

const CONTENT_SECTION_COUNT = 3;

export const EventPageSkeleton: FC = () => {
  return (
    <>
      <Container maxWidth="xl">
        <CategoriesLayoutStyled.CategoriesWrapper>
          <CategoriesSkeleton />
        </CategoriesLayoutStyled.CategoriesWrapper>
      </Container>

      <Container maxWidth="xl">
        <Styled.Root>
          <Stack sx={{
            gap: 3
          }}>
            <Stack sx={{
              gap: 0.5
            }}>
              <Skeleton variant="text" width="60%" height={20} />
              <Skeleton
                variant="text"
                height={20}
                sx={{ width: "40%", display: { xs: "block", md: "none" } }}
              />
            </Stack>

            <Stack
              direction="row"
              sx={{
                alignItems: "flex-start",
                gap: 2
              }}>
              <Styled.LeftContainer>
                <Styled.ContentStack>
                  <EventHeaderSkeleton />
                  <CoreChartSkeleton />
                  <NewsFeedSkeleton />
                </Styled.ContentStack>
              </Styled.LeftContainer>

              <Styled.RightContainer>
                <MarketCalculatorSkeleton />
              </Styled.RightContainer>
            </Stack>
          </Stack>

          <Styled.SectionsStack>
            <MarketsTabsSkeleton />

            {Array.from({ length: CONTENT_SECTION_COUNT }, (_, index) => (
              <Styled.EventSection key={index}>
                <Skeleton variant="text" width={200} height={28} />
                <Skeleton variant="text" width="100%" height={20} />
                <Skeleton variant="text" width="90%" height={20} />
                <Skeleton variant="text" width="60%" height={20} />
              </Styled.EventSection>
            ))}
          </Styled.SectionsStack>
        </Styled.Root>
      </Container>
    </>
  );
};
